import styled from "@emotion/styled";

import { colors } from "../../colors";
import type { PopoverContentStyledProps } from "./types";

export const PopoverContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const PopoverContent = styled.div<PopoverContentStyledProps>`
  position: absolute;
  z-index: ${(props) => props.$contentZIndex ?? 1000};
  min-width: ${(props) => {
    if (props.$matchTriggerWidth && props.$triggerWidth) {
      return `${props.$triggerWidth}px`;
    }
    return props.$contentMinWidth ?? "128px";
  }};
  max-width: ${(props) => {
    if (props.$matchTriggerWidth && props.$triggerWidth) {
      return `${props.$triggerWidth}px`;
    }
    return props.$contentMaxWidth ?? "none";
  }};
  width: ${(props) => {
    if (props.$matchTriggerWidth && props.$triggerWidth) {
      return `${props.$triggerWidth}px`;
    }
    return "auto";
  }};
  background: ${(props) => props.$contentBackground ?? colors.white};
  border: 1px solid ${(props) => props.$contentBorderColor ?? colors.gray[200]};
  border-radius: ${(props) => props.$contentBorderRadius ?? "6px"};
  box-shadow: ${(props) =>
    props.$contentBoxShadow ??
    "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)"};
  padding: ${(props) => props.$contentPadding ?? "8px"};
  overflow: hidden;

  ${(props) => {
    switch (props.$placement) {
      case "bottom-start":
        return `
          top: 100%;
          left: 0;
          margin-top: 4px;
        `;
      case "bottom-end":
        return `
          top: 100%;
          right: 0;
          margin-top: 4px;
        `;
      case "top-start":
        return `
          bottom: 100%;
          left: 0;
          margin-bottom: 4px;
        `;
      case "top-end":
        return `
          bottom: 100%;
          right: 0;
          margin-bottom: 4px;
        `;
      default:
        return `
          top: 100%;
          left: 0;
          margin-top: 4px;
        `;
    }
  }}
`;

export const PopoverArrow = styled.div`
  position: absolute;
  width: 8px;
  height: 8px;
  background: ${colors.white};
  border: 1px solid ${colors.gray[200]};
  border-radius: 2px;
  transform: rotate(45deg);
  pointer-events: none;
`;
